import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Divider, Select, Tag } from 'antd';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';
import PriceListActions from '@Actions/inventory/priceListActions';
import './style.scss';
import PRZSelect from '../UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
function SelectPriceList({
  getPriceLists, user, tenantId, showAddPriceList, priceLists, onChange, selectedPriceList, disabled, showError, getPopupContainer, title, hideTitle, containerClass, inputClassName, labelClassName, addPriceList, isMultiple, allowClear, customerId, state,
}) {
  useEffect(() => {
    getPriceLists(tenantId || user?.tenant_info?.tenant_id, null, 'false', customerId, state, 1, 1000, true, null);
  }, [tenantId, customerId, state]);

  return (
    <div
      className={
        `${containerClass} select-price-list__wrapper`
      }
    >
      {!hideTitle ? (
        <div className={labelClassName || 'orgFormLabel'}>
          {title || 'PriceList'}
          {showError && <span style={{ color: 'red' }}>{'  *'}</span>}
        </div>
      )
        : <Fragment />}
      <PRZSelect
        mode={isMultiple ? 'multiple' : ''}
        value={selectedPriceList}
        filterOption={false}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        disabled={disabled}
        onChange={(value) => {
          if (isMultiple) {
            const priceListArr = [];
            for (let i = 0; i < value?.length; i++) {
              priceListArr.push(value[i]);
            }
            onChange(priceListArr);
          } else {
            onChange(
              priceLists?.data.filter(
                (priceList) => priceList?.price_list_id === value,
              )[0],
            );
          }
        }}
        style={{
          borderRadius: '4px',
          height: '28px',
          width: '100%',
          padding: '0px',
        }}
        className={inputClassName || ' input'}
        showSearch
        allowClear={allowClear}
        onSelect={() => {
          getPriceLists(tenantId || user?.tenant_info?.tenant_id, null, 'false', customerId, state, 1, 1000, true, '');
        }}
        onSearch={(value) => {
          getPriceLists(tenantId || user?.tenant_info?.tenant_id, null, 'false', customerId, state, 1, 1000, true, value);
        }}
        maxTagCount="responsive"
        dropdownRender={
          showAddPriceList
            ? (menu) => (
              <React.Fragment>
                {menu}
                <Divider style={{ margin: '0px' }} />
                <div
                  className="add__customer"
                  onClick={() => addPriceList()}
                >
                  + Add Price List
                </div>
              </React.Fragment>
            )
            : false
        }
      >
        {priceLists
          && priceLists.data
          && priceLists.data?.map((item) => (
            <Option key={item.price_list_id} value={item.price_list_id}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ marginRight: '5px' }}>{`${item?.price_list_name} `}</div>
                <div>
                  {item?.price_list_type === 'ALL_ITEMS' ? (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {item?.pricing_rule === 'MARK_UP_PERCENTAGE' ? (
                        <div style={{ color: 'rgb(50,180,13)' }}>
                          <CaretUpOutlined />
                          <span>{`${item?.pricing_rule_percentage}%`}</span>
                        </div>
                      ) : (
                        <div style={{ color: 'rgb(201,28,28)' }}>
                          <CaretDownOutlined />
                          <span>{`${item?.pricing_rule_percentage}%`}</span>
                        </div>
                      )}
                    </div>
                  ) : (
                    <React.Fragment />
                  )}
                </div>
              </div>
            </Option>

          ))}
      </PRZSelect>
      {showError && (
        <div className="input-error">*Please select price list</div>
      )}
    </div>
  );
}

const mapStateToProps = ({ PriceListReducers, UserReducers }) => ({
  user: UserReducers.user,
  priceLists: PriceListReducers.priceLists,
  getPriceListsLoading: PriceListReducers.getPriceListsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getPriceLists: (tenantId, priceListId, isListScreen, customerId, states, page, limit, status, searchKeyword) => dispatch(PriceListActions.getPriceLists(tenantId, priceListId, isListScreen, customerId, states, page, limit, status, searchKeyword)),
});

SelectPriceList.propTypes = {
  user: PropTypes.any,
  priceLists: PropTypes.any,
  selectedPriceList: PropTypes.any,
  getPriceLists: PropTypes.func,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  showError: PropTypes.bool,
  title: PropTypes.any,
  hideTitle: PropTypes.bool,
  containerClass: PropTypes.any,
  inputClassName: PropTypes.any,
  labelClassName: PropTypes.string,
  tenantId: PropTypes.any,
  showAddPriceList: PropTypes.bool,
  getPopupContainer: PropTypes.any,
  addPriceList: PropTypes.any,
  isMultiple: PropTypes.any,
  allowClear: PropTypes.bool,
  customerId: PropTypes.any,
  state: PropTypes.any,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(SelectPriceList));
